export const normalizeMemberDetailsIoStatus = (status) => (
    String(status ?? '').trim().toLowerCase()
);

export const isMemberDetailsIoStatus = (status, expected) => (
    normalizeMemberDetailsIoStatus(status) === expected
);
